import { apiGet, apiPost, apiDelete } from './api';

export interface AuthUser {
  id: number;
  email: string;
  is_premium: number;
}

type AuthListener = (user: AuthUser | null) => void;
const listeners: AuthListener[] = [];
let currentUser: AuthUser | null = null;

function notify(user: AuthUser | null) {
  currentUser = user;
  listeners.forEach(fn => fn(user));
}

export function onAuthStateChange(callback: (user: AuthUser | null) => void) {
  listeners.push(callback);
  const token = localStorage.getItem('auth_token');
  if (token && !currentUser) {
    apiGet<{ user: AuthUser }>('/api/auth/me')
      .then(({ user }) => notify(user))
      .catch(() => {
        localStorage.removeItem('auth_token');
        notify(null);
      });
  } else {
    setTimeout(() => callback(currentUser), 0);
  }
  return {
    data: {
      subscription: {
        unsubscribe: () => {
          const idx = listeners.indexOf(callback);
          if (idx !== -1) listeners.splice(idx, 1);
        }
      }
    }
  };
}

export async function signIn(email: string, password: string) {
  const data = await apiPost<{ token: string; user: AuthUser }>('/api/auth/login', { email, password }, false);
  localStorage.setItem('auth_token', data.token);
  notify(data.user);
  return data;
}

export async function signUp(email: string, password: string) {
  const data = await apiPost<{ token: string; user: AuthUser }>('/api/auth/register', { email, password }, false);
  localStorage.setItem('auth_token', data.token);
  notify(data.user);
  return data;
}

export async function signOut() {
  localStorage.removeItem('auth_token');
  notify(null);
}

export async function updatePassword(currentPassword: string, newPassword: string) {
  await apiPost('/api/auth/change-password', { currentPassword, newPassword });
}

export async function deleteAccount() {
  await apiDelete('/api/auth/delete');
  localStorage.removeItem('auth_token');
  notify(null);
}

export async function resetPassword(_email: string) {
  throw new Error('Réinitialisation par email non disponible pour le moment. Contactez le support.');
}

export function getCurrentUser(): AuthUser | null {
  return currentUser;
}
